import { Reducer } from 'redux';
import {
  ViewUserReactivationState,
  ViewBulkActionReactivationTypes,
} from './types';

const INITIAL_STATE: ViewUserReactivationState = {
  data: [],
  hasError: false,
  isLoading: false,
  total: 0,
};

const reducer: Reducer<ViewUserReactivationState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case ViewBulkActionReactivationTypes.LOAD_VIEW_USERS_REACTIVATION_REQUEST:
      return { isLoading: true, hasError: false, data: [], total: 0 };
    case ViewBulkActionReactivationTypes.LOAD_VIEW_USERS_REACTIVATION_FAILURE:
      return { isLoading: false, hasError: true, data: [], total: 0 };
    case ViewBulkActionReactivationTypes.LOAD_VIEW_USERS_REACTIVATION_SUCCESS:
      return {
        isLoading: false,
        hasError: false,
        data: action.payload.data,
        total: action.payload.total,
      };

    default:
      return state;
  }
};

export default reducer;
